import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import {
	EvSiteNavigation,
	EvSiteNavigationCategory,
	EvSiteNavigationLink
} from '@evinced-private/ui-common';

import { getActiveNavigationItem } from '../../../helpers/ReleaseNotesNavigationHelper';
import { getReleaseNotesPath } from '../../../helpers/RoutesHelper';
import { ReleaseNotesProduct } from '../../../types/release-notes/ReleaseNotesProduct';

import { MAIN_CONTENT_ID } from './ContentArea';

interface IReleaseNotesNavigationProps {
	topLevelProducts: ReleaseNotesProduct[];
	selectedProduct: ReleaseNotesProduct | null;
	subproductSlug?: string;
}

export const ReleaseNotesNavigation: FC<IReleaseNotesNavigationProps> = ({
	topLevelProducts,
	selectedProduct,
	subproductSlug
}: IReleaseNotesNavigationProps) => {
	const history = useHistory();

	const activeItem = getActiveNavigationItem(topLevelProducts, selectedProduct, subproductSlug);

	const handleItemClick = (href: string): void => {
		history.push(href);
		// Focus the main content area after navigation
		// Use requestAnimationFrame to ensure DOM is ready
		requestAnimationFrame(() => {
			const mainContent = document.getElementById(MAIN_CONTENT_ID);
			if (mainContent) {
				mainContent.focus();
			}
		});
	};

	return (
		<EvSiteNavigation
			activeItem={activeItem}
			onItemClick={handleItemClick}
			ariaLabel="products release notes"
		>
			{topLevelProducts.map((product) => {
				const hasSubProducts = product.sub_products && product.sub_products.length > 0;

				if (hasSubProducts) {
					return (
						<EvSiteNavigationCategory key={product.id} name={product.name} id={product.slug}>
							{product.sub_products.map((subProduct) => (
								<EvSiteNavigationLink
									key={subProduct.id}
									href={getReleaseNotesPath(product.slug, subProduct.slug)}
								>
									{subProduct.name}
								</EvSiteNavigationLink>
							))}
						</EvSiteNavigationCategory>
					);
				}

				return (
					<EvSiteNavigationLink key={product.id} href={getReleaseNotesPath(product.slug)}>
						{product.name}
					</EvSiteNavigationLink>
				);
			})}
		</EvSiteNavigation>
	);
};
